import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { ActionIcons, CallBtn, CallHandlingBox, Decline, IconRow } from '../styles/dialpadstyle'
import { Button } from 'modules/theme';

export class CallHandlerTheme extends Component {
  render() {
    const {
      forceClose = true,
      ringing,
      onClickFuncMute,
      labelNameMute,
      iconMute,
      onClickFuncHold,
      labelNameHold,
      iconHold,
      onClickFuncKeypad,
      labelNameKeypad,
      iconKeypad,
      onClickFuncTag,
      labelNameTag,
      iconTag,
      onClickFuncAddCall,
      labelNameAddCall,
      iconAddCall,
      onClickFuncInfo,
      labelNameInfo,
      iconInfo,
      onClickBtn,
      btn
    } = this.props;
    return (
      <div>
        <CallHandlingBox>
          <IconRow>
            <ActionIcons>
              <a style={{cursor: ringing ? "not-allowed" : "pointer"}}  onClick={ !ringing ? onClickFuncMute : "" }>
                <i>
                  {iconMute}
                </i>
                <label>{labelNameMute}</label>
              </a>
            </ActionIcons>
            <ActionIcons>
              <a style={{cursor: ringing ? "not-allowed" : "pointer"}}  onClick={ !ringing ? onClickFuncHold :""}>
                <i>
                  {iconHold}
                </i>
                <label>{labelNameHold}</label>
              </a>
            </ActionIcons>
            <ActionIcons>
              <a style={{cursor: ringing ? "not-allowed" : "pointer"}}  onClick={ !ringing ? onClickFuncKeypad :""}>
                <i>
                  {iconKeypad}
                </i>
                <label>{labelNameKeypad}</label>
              </a>
            </ActionIcons>
          </IconRow>
          <IconRow>
            <ActionIcons>
              <a style={{cursor: ringing ? "not-allowed" : "pointer"}}  onClick={ !ringing ? onClickFuncTag :""}>
                <i>
                  {iconTag}
                </i>
                <label>{labelNameTag}</label>
              </a>
            </ActionIcons>
            <ActionIcons>
              <a style={{cursor: ringing ? "not-allowed" : "pointer"}} onClick={ !ringing ? onClickFuncAddCall : ()=> console.log("Not Allowed")}>
                <i>
                  {iconAddCall}
                </i>
                <label>{labelNameAddCall}</label>
              </a>
            </ActionIcons>
            <ActionIcons>
              {/* <a style={{cursor: ringing ? "not-allowed" : "pointer"}} onClick={ !ringing ? onClickFuncInfo :""}> */}
              <a style={{cursor:"pointer"}} onClick={ onClickFuncInfo }>
                <i>
                  {iconInfo}
                </i>
                <label>{labelNameInfo}</label>
              </a>
            </ActionIcons>
          </IconRow>
          <CallBtn>
            <Decline style={{width: '100%'}}>
              <i style={{cursor: "pointer"}} onClick={onClickBtn}>
                <img src={btn} />
              </i>
            </Decline>
          </CallBtn>
          {/* <div className="circle">
            <img src="/images/BiDialpadAlt.png" style={{ padding: '13px' }} />
          </div>
          <div className="circle">
            <img
              onClick={this.callHoldToggle}
              src="/images/AiOutlineUserAdd.png"
            />
          </div>
          <div className="circle">
            <img
              onClick={this.callMuteToggle}
              src="/images/AiOutlinePause.png"
            />
          </div>
          <div className="circle">
            <img src="/images/MdEditNote.png" />
          </div> */}
        </CallHandlingBox>
        {/* <CallBtn>
          <button className="" onClick={this.callHangup}>
            End
          </button>
        </CallBtn> */}
      </div>
    )
  }
}

CallHandlerTheme.propTypes = {
  isConnected: PropTypes.bool.isRequired
};

CallHandlerTheme.contextTypes = {
  __: PropTypes.func
};

export default CallHandlerTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/CallHandlerTheme.js